import { Flex, Input, InputGroup, InputRightElement, Skeleton } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import {  PageTitle } from '../../components'
import style from './task-type.module.css'
import { useTranslation } from 'react-i18next'
import TableTaskTypeV2 from './components/TableTaskTypeV2'
import { TaskTypeListPayloadProps } from '../../services/taskTypeService/taskTypeService.interface'
import { useMutation } from 'react-query'
import taskTypeService from '../../services/taskTypeService/taskTypeService'
import { useDebouncedCallback } from 'use-debounce'
import { headingTheme } from '../../theme/components'

const TaskType = () => {
    const { t } = useTranslation()

    const [taskTypeListFilter, setTaskTypeListFilter] = useState<TaskTypeListPayloadProps>({
        is_active: 1,
        show: 10,
        search: '',
        with_member_access_count: 1,
    })

    const taskTypeListMutation = useMutation(taskTypeService.list)
    const debouncedSearch = useDebouncedCallback(
        (value) => {
            setTaskTypeListFilter((prev) => {
            return {
                ...prev,
                search: value,
                page: 1
            }
        })
        },
        1500
    );


    function handlePagination(page: number) {
        setTaskTypeListFilter((prev) => {
            return {
                ...prev,
                page
            }
        })
    }

    useEffect(() => {
        taskTypeListMutation?.mutate(taskTypeListFilter)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskTypeListFilter])

    return (
        <Flex className={`${style.task_type}`}>
            <PageTitle text={t("tipe_tugas_judul")} />

            <InputGroup width="max-content">
                <InputRightElement
                    children={<span className={`material-symbols-outlined ${style.icon}`}>search</span>}
                />
                <Input
                    {...headingTheme.sizes.chakra_label_large}
                    type="search"
                    width="300px"
                    placeholder={t("tipe_tugas_pencarian_placeholder")}
                    defaultValue={taskTypeListFilter?.search}
                    onChange={(e) => debouncedSearch(e.target.value)}
                />
            </InputGroup>

            {taskTypeListMutation?.isLoading || taskTypeListMutation?.isIdle
                ?   <Skeleton height={"571px"} width={"100%"} />
                :   taskTypeListMutation?.data?.data && taskTypeListMutation?.data?.metadata
                    ?   <TableTaskTypeV2 
                            data={taskTypeListMutation?.data?.data} 
                            metadata={taskTypeListMutation?.data?.metadata} 
                            isLoading={taskTypeListMutation?.isLoading}
                            handlePagination={handlePagination}
                        />
                    :   null
            }
        </Flex>
    )
}

export default TaskType